<template>
    <Card parentTag="a">
        <div slot="card-body" @click.prevent="handleClick" class="card-button">
            <div class="card-button__icon">
                <i class="icon" :class="iconClassName" />
            </div>
            <div :class="subText === null ? 'card-button__default' : ''">
                <p class="card-button__label">
                        {{ label }}
                </p>
                <p v-if="subText !== null" class="card-button__subText">
                        {{ subText }}
                </p>
            </div>
        </div>
    </Card>
</template>

<script>
import Card from '@/components/shells/card/card.vue';
import variantClasses from './variant-classes/card-variant-classes';

export default {
    name: 'CardButton',
    mixins: [variantClasses],
    components: {
        Card
    },
    props: {
        iconClassName: {
            type: String,
            default: undefined
        },
        label: {
            type: String,
            default: null
        },
        subText: {
            type: String,
            default: null
        }
    },
    computed: {},
    methods: {
        handleClick(event) {
            if (this.$listeners.click) {
                event.preventDefault();
            }
            this.$emit('click');
        }
    }
};
</script>

<style lang="scss" scoped>
.card {
    min-width: 200px;
    &__main {
        &:hover,
        &:focus-within {
            background: var(--bg-2);
            .card-button__label,
             .card-button__icon,
            .card-button__subText {
                color: var(--brand-2);
            }
        }
    }

    &-button {
        display: flex;
        justify-content: center;
        gap: $gutter-lg;
        padding: $padding-sm;

        &__icon {
            font-size: 32px;
            color: var(--bg-1-fg-3); 
        }

        &__label {
            font-weight: $bold-font-weight;
            font-size: $btn-font-size;
            color: var(--bg-1-fg-3);

        }

        &__subText {
            font-weight: $regular-font-weight;
            font-size: $btn-font-size;
            color: var(--bg-1-fg-2);
            margin-top: $gutter-md;
        }

        &__default {
            align-content: center;
        }
    }
}
</style>